import CopyFilters from './copyFilters';

export default CopyFilters;
